export const SCREEN_RESIZED = 'SCREEN_RESIZED';

export const screenWasResized = w => ({
    type: SCREEN_RESIZED,
    payload: {
        width: w,
    },
});
